import "core-js/stable";
import "regenerator-runtime/runtime";
import { async } from "regenerator-runtime";

class dayView {
  #parentElement = document.querySelector(".forecast-days-container");
  #data;
  #joinedMarkup = "";
  forcastNum = 7;
  forcastSelection = document.querySelector(".forecast-selection");
  buttonLeft = document.querySelector(".btn-left-day");
  buttonRight = document.querySelector(".btn-right-day");

  render(data) {
    this.#data = data;

    this.#clear();
    this.joinMarkup();
    const markup = this.#joinedMarkup;
    this.#parentElement.insertAdjacentHTML("afterbegin", markup);
  }

  #clear() {
    this.#parentElement.innerHTML = "";
    this.#joinedMarkup = "";
  }

  joinMarkup() {
    for (let i = 0; i < this.forcastSelection.value; i++) {
      this.#joinedMarkup = this.#joinedMarkup + this.#generateMarkup(i);
    }
  }

  #generateMarkup(i) {
    return `<div data-day=${i} class="forecast-day-box">
    <p class="forecast-day">${
      this.#data.weatherData.daily.dailyGroup[i].day
    }</p>
    <img
      src="${this.#data.weatherData.daily.dailyGroup[i].icon}"
      alt=""
      class="days-icon icon"
    />
    <div class="days-box-temps-container">
      <div class="temp-day-high">
        <span class="temp">${
          this.#data.tempUnit === "celcius"
            ? this.#data.weatherData.daily.dailyGroup[i].tempMax
            : this.#data.weatherData.daily.dailyGroup[i].tempMaxF
        }</span
        ><span class="degree-symbol">°</span>
      </div>
      <div class="temp-day-low">
        <span class="temp">${
          this.#data.tempUnit === "celcius"
            ? this.#data.weatherData.daily.dailyGroup[i].tempMin
            : this.#data.weatherData.daily.dailyGroup[i].tempMinF
        }</span
        ><span class="degree-symbol">°</span>
      </div>
    </div>
    <div class="days-description-container">
    <span class="days-description">${
      this.#data.weatherData.daily.dailyGroup[i].description
    }</span>
    </div>
  </div>`;
  }

  addHandlerChangeForcast(handler) {
    this.forcastSelection.addEventListener(
      "change",
      function () {
        handler();
      }.bind(this)
    );
  }

  addActiveClass() {
    this.#parentElement.childNodes[0].classList.add("forecast-day-box--active");
  }

  addHandlerClick(handler) {
    this.#parentElement.addEventListener(
      "click",
      function (e) {
        this.#parentElement.childNodes.forEach((child) => {
          child.classList.remove("forecast-day-box--active");
        });
        const day = e.target.closest(".forecast-day-box");
        day.classList.add("forecast-day-box--active");
        if (!day) return;

        const currentDay = day.dataset.day;
        handler(currentDay);
      }.bind(this)
    );
  }

  addHandlerButtonRight() {
    this.buttonRight.addEventListener(
      "click",
      function () {
        this.#parentElement.scrollBy({
          top: 0,
          left: +500,
          behavior: "smooth",
        });

        console.log("fireright");
      }.bind(this)
    );
  }

  addHandlerButtonLeft() {
    this.buttonLeft.addEventListener(
      "click",
      function () {
        this.#parentElement.scrollBy({
          top: 0,
          left: -500,
          behavior: "smooth",
        });
        console.log(this.#parentElement);
        console.log("fireleft");
      }.bind(this)
    );
  }
}

export default new dayView();
